import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";

export default class BaseAnticipation {
    constructor() {

    }

    public play(reelId: number) {
        let scene = ViewManager.getLayer(DefaultLayers.Anticipation).setScene("anticipation_" + reelId);
    }

    public stop(reelsSpinning: number , reelId?: number) {
        if (!reelsSpinning) {
            let scene = ViewManager.getLayer(DefaultLayers.Anticipation).clear();
        }
    }
}